export const SOCIALS = {
  DISCORD: "https://discord.gg/X4fwgzPReJ",
  TWITTER: "https://x.com/karmahq_",
  LINKEDIN: "https://www.linkedin.com/company/karmaxyz/",
  WEBSITE: "https://karmahq.xyz",
  TELEGRAM: "https://t.me/karmahq",
  PARAGRAPH: "https://paragraph.xyz/@karmahq",
  X_HANDLE: "@karmahq_",
  DOCS: "https://docs.gap.karmahq.xyz",
  PARTNER_FORM: "https://tally.so/r/3NKZEl",
};
